<template>
  <b-container fluid>
    <div>
      <BaseFacilitySelect></BaseFacilitySelect>
    </div>
    <div>
      <div class="card">
        <div class="card-header">
          <strong>History of RespSafe program participation</strong>
        </div>
        <div class="card-body">
          <div>
            <p>
              View submitted influenza and COVID vaccination numbers from previous years.
              Numbers for the current season will be added below once this year’s report is submitted.
              Select the ‘Download history’ button to save a copy of the table in a PDF form.
            </p>
          </div>
          <div>
            <span v-if="!this.$store.state.selectedFacility"><em style="color: #c70000;">Please select a facility.</em></span>
            <b-tabs v-show="this.$store.state.selectedFacility">
              <b-tab title="Influenza">
                <div>
                  <FluHistoryTable></FluHistoryTable>
                </div>
              </b-tab>
              <b-tab title="COVID">
                <div>
                  <CovidHistoryTable></CovidHistoryTable>
                </div>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>
  </b-container>
</template>

<script>

import BaseFacilitySelect from "@/components/templates/input/BaseFacilitySelect.vue";
import axios from "axios";
import router from "@/router";
import FluHistoryTable from "@/components/FluHistoryTable.vue";
import CovidHistoryTable from "@/components/CovidHistoryTable.vue";

export default {
  name: 'respSafeSubmissionConfirmation',
  components: {CovidHistoryTable, FluHistoryTable, BaseFacilitySelect},
  data: () => ({

  }),

  mounted() {
  },

  methods: {

    checkRegistration() {
      axios.get(`${process.env.VUE_APP_API_BASE_URL}/user/org`).then(response => {
        this.org = response.data
        if(this.org !== null && this.$store.state.selectedFacility) {
          axios.get(`${process.env.VUE_APP_API_BASE_URL}/respsafe/registration/${this.$store.state.selectedFacility.id}`)
            .then(response => {
              if (response.data[0].id === null) { // no registration found
                this.pushMissingModal()
              } else {
                axios.get(`${process.env.VUE_APP_API_BASE_URL}/respsafe/report/${this.$store.state.selectedFacility.id}`)
                  .then(response => {
                    if (response.data[0].reportId !== null && response.data[0].registration.respiratorySeason === this.respiratorySeason) {
                      this.reportSubmissionDate = this.formatDate(response.data[0].reportDate)
                      this.pushDuplicateModal()
                    } else {
                      this.pushReportModulePage()
                    }
                  })
              }
            })
        } else {
          this.showRootToast('Error','Please select a facility.','danger')
        }
      })
    },

    showRootToast(title, message, type) {
      this.$root.$bvToast.toast(message, {
        title: title,
        toaster: 'b-toaster-top-center',
        solid: true,
        variant: type,
        appendToast: true
      })
    },
  }
}
</script>
<style scoped>
em {
  padding-top: 1em;
}
</style>
